// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"942":"42e7531e5d716aff","7456":"ed974515b9c811e6"}[chunkId] + ".css";
};